export default "__VITE_ASSET__CEHxGaQZ__"